import { useEffect, useState } from "react"
import { StrIndexedObj } from "../misc"

/* Input types that are expected to change size on input overflow */
const changeableInputTypes = ["text","email","password","url"]

export const useFormHandler = <FormDataType extends {}>(formPreset: FormDataType, submitFunction?: Function, changeInputSize: boolean = true) => {
    const [formData, setFormData] = useState(formPreset)

    let inputSizeMap: StrIndexedObj  = {}

    useEffect(() => {
        onkeyup = (e) => {if (e.key === "Enter") {if (submitFunction) {submitFunction()}}};
    }, [submitFunction])

    const formChange = (e: any) => {

        onChange(formData, setFormData, e)

        if (!Object.keys(inputSizeMap).includes(e.target.id)) {
            inputSizeMap[e.target.id] = e.target.style.width
            return
        }

        if (changeInputSize && changeableInputTypes.includes(e.target.type)) {changeInputWidth(e, inputSizeMap)}
    }

    return {formData, setFormData, formChange}
}

const onChange = (data: Object, setData: Function, e: any) => { //UNUSED
    let temp = data;
    let id: keyof typeof temp = e.target.id;
    temp[id] = e.target.value;
    setData(temp);
    return
  };

const changeInputWidth = (e: any, sizeMap: StrIndexedObj) => {
    let newWidth = (e.target.value.length /* (0.95 - e.target.value.length * 0.01)*/) + 'ch'; //random ass multipliers
    e.target.style.width = e.target.value.length > 0 ? newWidth : sizeMap[e.target.id]
    return
}
  